const requestAnimationFrame = (func) => {
  window.requestAnimationFrame(func);
};

export default { requestAnimationFrame };
